import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallMergeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call_merge"}/>
}
